
let defaultState = {

    active: true,
}

export default function (state=defaultState, action) {

    switch (action.type) {

        case "SPEECH_START":
            return {active: false}

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/tutorial.js